import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { AuthContextProvider } from './context/authContext';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthContextProvider>
    <HashRouter>
      <App/>
    </HashRouter>
    </AuthContextProvider>
  </React.StrictMode>
);